<template>
    <audio ref="audio" autoplay></audio>
</template>

<script>
    export default {
        name: "full-video-audio",
        props: {
            info: {
                type: Object,
                default() {
                    return Object.create(null)
                }
            }
        },
        mounted(){
            this.init();
        },
        watch:{
            info(){
                this.init();
            }
        },
        methods:{
            init() {
                const {type,audioStream} = this.info;
                if (type === 'audio') {
                    this.$refs.audio.srcObject = audioStream;
                }
            },
        }
    }
</script>

<style scoped>

</style>